const config = {
    apiKey: 'ZP6THStw9mnhbHrmWQaig_an05aFdouwf8wKtArDIS4=',
    siteID: 'cf76f10a-2e9e-435c-a8ee-9317aefa14c8',
    baseURL: 'https://chatbotback.azurewebsites.net/',
    accessToken: null,
    chatbotTitle: 'E-commerce AI assistant',
    chatbotCSS: 'https://chatbotback.azurewebsites.net/scripts/chatbot.css',
    chatbotJS: 'https://chatbotback.azurewebsites.net/scripts/chatbot.js',
};

export default config;
